module.exports = __webpack_public_path__ + "static/media/huli_406.31974d68.gif";